<template>
  <v-layout row justify-center align-start v-resize="getDimensions">
    <v-flex>
      <v-app-bar flat color="white">
        <v-toolbar-title class="font-weight-black primary--text"
          >Configuración de Otros Gastos de Personal</v-toolbar-title
        >
        <v-spacer></v-spacer>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              large
              @click="addItem"
              color="primary"
              v-bind="attrs"
              v-on="on"
              :disabled="!id_presupuesto_filtro"
            >
              <v-icon dark> add </v-icon>
            </v-btn>
          </template>
          <span>Ingresar nueva configuración</span>
        </v-tooltip>
      </v-app-bar>

      <v-card flat class="px-4 py-2">
        <v-row>
          <v-col cols="12" sm="6" md="4">
            <v-autocomplete
              outlined
              dense
              v-model="id_presupuesto_filtro"
              :items="presupuestos"
              item-text="descripcion"
              item-value="id"
              label="Seleccione un Presupuesto (Gestión)"
              @change="listar"
              hide-details
            ></v-autocomplete>
          </v-col>
        </v-row>
      </v-card>

      <v-sheet class="overflow-y-auto" :max-height="height">
        <v-data-table
          dense
          fixed-header
          :height="height - (isMobile ? 180 : 250)"
          :headers="headers"
          :items="configs"
          :items-per-page="50"
          :search="search"
          sort-by="subcategoria"
          class="elevation-1"
          :footer-props="{
            showFirstLastPage: true,
            'items-per-page-text': 'Filas por página',
            'items-per-page-options': [-1, 50, 100, 150],
          }"
        >
          <template v-slot:[`item.opciones`]="{ item }">
            <v-btn x-small text dark color="primary" @click="editItem(item)">
              <v-icon x-small>edit</v-icon>
            </v-btn>
          </template>

          <template v-slot:[`item.monto`]="{ item }">
            <div v-if="item.es_porcentaje">{{ item.monto }} %</div>
            <div v-else>
              {{ item.monto }}
            </div>
          </template>
          
          <template v-slot:[`item.estado`]="{ item }">
            <div v-if="item.estado == 'A'">
              <v-btn
                color="success"
                x-small
                text
                dark
                @click="desactivar(item)"
              >
                <v-icon x-small>check</v-icon>
              </v-btn>
            </div>
            <div v-else>
              <v-btn color="error" x-small text dark @click="activar(item)">
                <v-icon x-small>block</v-icon>
              </v-btn>
            </div>
          </template>

          <template v-slot:top>
            <v-toolbar flat color="white">
              <v-text-field
                outlined
                dense
                class="text-xs-center"
                v-model="search"
                append-icon="search"
                label="Búsqueda General"
                hide-details
              ></v-text-field>

              <v-dialog
                v-model="dialog"
                fullscreen persistent
              >
                <v-card ref="form">
                  <v-app-bar color="white" elevate-on-scroll flat>
                    <span class="font-weight-black primary--text"
                      >{{ formTitle }}
                    </span>

                    <v-spacer></v-spacer>

                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          large
                          @click="guardar"
                          color="primary"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon dark> fa-solid fa-floppy-disk </v-icon>
                        </v-btn>
                      </template>
                      <span>Guardar</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          large
                          @click="close"
                          color="primary"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon dark> fa-solid fa-xmark </v-icon>
                        </v-btn>
                      </template>
                      <span>Volver</span>
                    </v-tooltip>
                  </v-app-bar>

                  <v-card-text>
                    <v-row>
                      <!-- Columna Izquierda: Datos Básicos -->
                      <v-col cols="12" md="6">
                        <v-autocomplete
                          outlined
                          dense
                          ref="id_subcategoria"
                          v-model="id_subcategoria"
                          :items="subcategorias"
                          :rules="[$rules.requerido]"
                          :error-messages="errorMessages"
                          :readonly="editedIndex > -1"
                          item-text="descripcion"
                          item-value="id"
                          label="Subcategoría"
                          required
                        ></v-autocomplete>

                        <v-autocomplete
                          outlined
                          dense
                          ref="formula"
                          v-model="formula"
                          :items="formulas"
                          :error-messages="errorMessages"
                          item-text="descripcion"
                          item-value="id"
                          label="Formula"
                          clearable
                        ></v-autocomplete>

                        <v-text-field
                          outlined
                          dense
                          reverse
                          ref="monto"
                          v-model="monto"
                          :rules="[$rules.numero]"
                          :error-messages="errorMessages"
                          label="Monto"
                          style="text-align: right"
                        >
                          <template v-slot:append-outer>
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  icon
                                  large
                                  color="primary"
                                  @click="es_porcentaje = !es_porcentaje"
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  <v-icon dark>
                                    {{
                                      !es_porcentaje
                                        ? "check_box_outline_blank"
                                        : "check_box"
                                    }}
                                  </v-icon>
                                </v-btn>
                              </template>
                              <span>{{ "¿Es porcentaje?" }}</span>
                            </v-tooltip>
                          </template>
                        </v-text-field>

                        <v-checkbox
                          v-model="mes_cumple"
                          @click="borrarMeses()"
                        >
                          <template v-slot:label>
                            <div>Se calcula en el mes de cumpleaños?</div>
                          </template>
                        </v-checkbox>
                        <v-checkbox
                          v-model="mes_ingreso"
                          @click="borrarMeses()"
                        >
                          <template v-slot:label>
                            <div>Se calcula en el mes de ingreso?</div>
                          </template>
                        </v-checkbox>
                        
                        <v-autocomplete
                          v-show="!mes_cumple && !mes_ingreso"
                          outlined
                          dense
                          chips
                          deletable-chips
                          small-chips
                          multiple
                          ref="mes"
                          v-model="mes"
                          :items="meses"
                          :error-messages="errorMessages"
                          label="Meses a Asignar"
                          item-text="descripcion"
                          item-value="id"
                        >
                          <template v-slot:append-outer>
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  icon
                                  large
                                  @click="selectAllMeses"
                                  color="primary"
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  <v-icon dark>
                                    {{ !todosMeses ? "check_box_outline_blank" : "check_box" }}
                                  </v-icon>
                                </v-btn>
                              </template>
                              <span>{{ !todosMeses ? "Seleccionar todos" : "Borrar selección" }}</span>
                            </v-tooltip>
                          </template>
                        </v-autocomplete>
                      </v-col>

                      <!-- Columna Derecha: Filtros adicionales -->
                      <v-col cols="12" md="6">
                        <v-checkbox
                          v-model="particular"
                          @click="borrarFiltrosAdicionales"
                        >
                          <template v-slot:label>
                            <div>¿Se calcula para un grupo específico de Personas?</div>
                          </template>
                        </v-checkbox>

                        <div v-show="particular">
                          <v-system-bar color="white" class="px-0">
                            <v-icon>{{
                              personasTableSelected.length === 0
                                ? "fa-regular fa-circle"
                                : personasTableSelected.length === 1
                                ? "fa-solid fa-user"
                                : "fa-solid fa-users"
                            }}</v-icon>
                            <span class="ml-2 font-weight-medium">
                              {{ personasTableSelected.length }} / {{ personas.length }} personas seleccionadas
                            </span>
                          </v-system-bar>
                          
                          <v-text-field
                            v-model="searchPersona"
                            append-icon="search"
                            label="Buscar por código o nombre"
                            single-line
                            hide-details
                            dense
                            outlined
                            class="mb-2 mt-1"
                          ></v-text-field>

                          <v-data-table
                            dense
                            fixed-header
                            height="350"
                            :items="personasOrdenadas"
                            v-model="personasTableSelected"
                            :headers="headersPersona"
                            :search="searchPersona"
                            item-key="id"
                            show-select
                            :hide-default-header="false"
                            :hide-default-footer="true"
                            class="elevation-1"
                            checkbox-color="primary"
                            :footer-props="{
                              'items-per-page-options': [-1,  100],
                              'items-per-page-text': 'Filas',
                            }"
                            :items-per-page="50"
                          ></v-data-table>
                        </div>

                        <div v-show="!particular">
                          <v-checkbox v-model="para_padres">
                            <template v-slot:label>
                              <div>¿Se calcula solo para los Padres?</div>
                            </template>
                          </v-checkbox>

                          <v-autocomplete
                            v-show="para_padres"
                            outlined
                            dense
                            chips
                            deletable-chips
                            multiple
                            ref="nivel_hijo"
                            v-model="nivel_hijo"
                            :items="niveles"
                            :error-messages="errorMessages"
                            item-text="descripcion"
                            item-value="id"
                            label="Nivel Educativo"
                          ></v-autocomplete>

                          <v-autocomplete
                            outlined
                            dense
                            chips
                            deletable-chips
                            multiple
                            ref="id_ciudad"
                            v-model="id_ciudad"
                            :items="ciudades"
                            :error-messages="errorMessages"
                            item-text="descripcion"
                            item-value="id"
                            label="Ciudades"
                          >
                            <template v-slot:append-outer>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    icon
                                    large
                                    @click="selectAllCiudades"
                                    color="primary"
                                    v-bind="attrs"
                                    v-on="on"
                                  >
                                    <v-icon dark>
                                      {{ !todosCiudades ? "check_box_outline_blank" : "check_box" }}
                                    </v-icon>
                                  </v-btn>
                                </template>
                                <span>{{ !todosCiudades ? "Seleccionar todos" : "Borrar selección" }}</span>
                              </v-tooltip>
                            </template>
                          </v-autocomplete>

                          <v-autocomplete
                            outlined
                            dense
                            chips
                            deletable-chips
                            multiple
                            small-chips
                            ref="genero"
                            @change="todosGeneros = false"
                            v-model="genero"
                            :items="generos"
                            :error-messages="errorMessages"
                            item-text="descripcion"
                            item-value="id"
                            label="Género"
                          >
                            <template v-slot:append-outer>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    icon
                                    large
                                    @click="selectAllGeneros"
                                    color="primary"
                                    v-bind="attrs"
                                    v-on="on"
                                  >
                                    <v-icon dark>
                                      {{ !todosGeneros ? "check_box_outline_blank" : "check_box" }}
                                    </v-icon>
                                  </v-btn>
                                </template>
                                <span>{{ !todosGeneros ? "Seleccionar todos" : "Borrar selección" }}</span>
                              </v-tooltip>
                            </template>
                          </v-autocomplete>

                          <v-autocomplete
                            outlined
                            dense
                            chips
                            deletable-chips
                            multiple
                            small-chips
                            ref="cargo"
                            v-model="cargo"
                            :items="cargos"
                            :error-messages="errorMessages"
                            item-text="descripcion"
                            item-value="id"
                            label="Cargos"
                          >
                            <template v-slot:append-outer>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    icon
                                    large
                                    color="primary"
                                    @click="selectAllCargos"
                                    v-bind="attrs"
                                    v-on="on"
                                  >
                                    <v-icon dark>
                                      {{ !todosCargos ? "check_box_outline_blank" : "check_box" }}
                                    </v-icon>
                                  </v-btn>
                                </template>
                                <span>{{ !todosCargos ? "Seleccionar todos" : "Borrar selección" }}</span>
                              </v-tooltip>
                            </template>
                          </v-autocomplete>
                        </div>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </v-toolbar>
          </template>

          <template v-slot:no-data>
            <v-btn color="primary" @click="listar">Reset</v-btn>
          </template>
        </v-data-table>
      </v-sheet>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      width: 0,
      height: 0,
      isMobile: false,
      
      presupuestos: [],
      id_presupuesto_filtro: "",
      
      configs: [],
      subcategorias: [],
      personas: [],
      personasOrdenadas: [],
      ciudades: [],
      cargos: [],
      
      formulas: [
        { id: "Ninguna", descripcion: "Ninguna" },
        { id: "Promediar", descripcion: "Promediar Montos" },
        { id: "BasadoSueldo", descripcion: "Fórmula basada en Sueldo" },
        { id: "BasadoComision", descripcion: "Fórmula basada en Comisiones" },
        { id: "CargaMasiva", descripcion: "Obtenido por medio de Carga Masiva" },
        { id: "BasadoSueldoComision", descripcion: "Fórmula basada en Sueldo y Comisiones" },
        { id: "HijoInicial", descripcion: "Para hijos en Nivel Inicial" },
        { id: "HijoPrimaria", descripcion: "Para niños en Nivel Primario" },
        { id: "HijoSecundaria", descripcion: "Para niños en Nivel Secundario" },
        { id: "HijoUniversidad", descripcion: "Para niños en Universidad" },
      ],
      niveles: [
        { id: "I", descripcion: "INICIAL" },
        { id: "P", descripcion: "PRIMARIO" },
        { id: "S", descripcion: "SECUNDARIO" },
        { id: "U", descripcion: "UNIVERSIDAD" },
      ],
      meses: [
        { id: 1, descripcion: "ENERO" },
        { id: 2, descripcion: "FEBRERO" },
        { id: 3, descripcion: "MARZO" },
        { id: 4, descripcion: "ABRIL" },
        { id: 5, descripcion: "MAYO" },
        { id: 6, descripcion: "JUNIO" },
        { id: 7, descripcion: "JULIO" },
        { id: 8, descripcion: "AGOSTO" },
        { id: 9, descripcion: "SEPTIEMBRE" },
        { id: 10, descripcion: "OCTUBRE" },
        { id: 11, descripcion: "NOVIEMBRE" },
        { id: 12, descripcion: "DICIEMBRE" },
      ],
      generos: [
        { id: "M", descripcion: "MASCULINO" },
        { id: "F", descripcion: "FEMENINO" },
      ],
      
      dialog: false,
      usuario: this.$store.state.usuario.user,
      
      headers: [
        { text: "Opciones", value: "opciones", sortable: false, width: "5%", align: "center", class: "primary white--text text-subtitle-2" },
        { text: "Código Subcategoría", value: "codigo_subcategoria", align: "left", class: "primary white--text text-subtitle-2" },
        { text: "Subcategoría", value: "subcategoria", align: "left", class: "primary white--text text-subtitle-2" },
        { text: "Fórmula", value: "formula", align: "left", class: "primary white--text text-subtitle-2" },
        { text: "Monto", value: "monto", align: "right", class: "primary white--text text-subtitle-2" },
        { text: "Activo", value: "estado", align: "center", class: "primary white--text text-subtitle-2" },
      ],
      search: "",
      searchPersona: "",
      personasTableSelected: [],
      headersPersona: [
        { text: "Código", value: "codigo", class: "primary white--text text-subtitle-2" },
        { text: "Persona", value: "nombre_completo", class: "primary white--text text-subtitle-2" },
        { text: "Cargo", value: "cargo", class: "primary white--text text-subtitle-2" },
      ],
      
      editedIndex: -1,
      id: "",
      id_subcategoria: "",
      formula: "",
      monto: 0,
      es_porcentaje: false,
      mes_cumple: false,
      mes_ingreso: false,
      particular: false,
      para_padres: false,
      mes: [],
      genero: [],
      id_ciudad: [],
      nivel_hijo: [],
      cargo: [],
      persona: [],
      
      todosMeses: false,
      todosGeneros: false,
      todosCiudades: false,
      todosCargos: false,
      
      valida: 0,
      errorMessages: "",
    };
  },

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nueva Configuración" : "Actualizar Configuración";
    },
    form() {
      return {
        id_subcategoria: this.id_subcategoria,
      };
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    personasTableSelected(newVal) {
      this.persona = newVal.map(p => p.id);
    }
  },

  mounted() {
    this.getDimensions();
  },

  created() {
    this.selectPresupuestos();
    this.selectSubcategorias();
    this.listarPersonas();
    this.selectCiudades();
    this.selectCargos();
  },

  methods: {
    getDimensions() {
      this.width = window.innerWidth;
      this.height = window.innerHeight;
      this.isMobile = this.width < 768;
    },

    selectPresupuestos() {
      let me = this;
      axios.get("api/presupuestos/Select")
        .then(function (response) {
          me.presupuestos = response.data;
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", { text: error, color: "error" });
        });
    },

    selectSubcategorias() {
      let me = this;
      axios.get("api/subcategorias/Select")
        .then(function (response) {
          me.subcategorias = response.data;
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", { text: error, color: "error" });
        });
    },

    listarPersonas() {
      let me = this;
      axios.get("api/personas/listar/false")
        .then(function (response) {
          me.personas = response.data;
          me.personasOrdenadas = [...me.personas];
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", { text: error, color: "error" });
        });
    },

    selectCiudades() {
      let me = this;
      axios.get("api/ciudades/SelectDepartamentosBolivia")
        .then(function (response) {
          me.ciudades = response.data;
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", { text: error, color: "error" });
        });
    },

    selectCargos() {
      let me = this;
      axios.get("api/cargos/select")
        .then(function (response) {
          me.cargos = response.data;
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", { text: error, color: "error" });
        });
    },

    listar() {
      let me = this;
      if (!me.id_presupuesto_filtro) return;
      axios.get("api/Subcategoria_configs/Listar/" + me.id_presupuesto_filtro)
        .then(function (response) {
          me.configs = response.data;
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", { text: error, color: "error" });
        });
    },

    selectAllGeneros() {
      this.todosGeneros = !this.todosGeneros;
      this.genero = this.todosGeneros ? this.generos.map((x) => x.id) : [];
    },
    selectAllCiudades() {
      this.todosCiudades = !this.todosCiudades;
      this.id_ciudad = this.todosCiudades ? this.ciudades.map((x) => x.id) : [];
    },
    selectAllCargos() {
      this.todosCargos = !this.todosCargos;
      this.cargo = this.todosCargos ? this.cargos.map((x) => x.id) : [];
    },
    selectAllMeses() {
      this.todosMeses = !this.todosMeses;
      this.mes = this.todosMeses ? this.meses.map((x) => x.id) : [];
    },

    borrarMeses() {
      this.mes = [];
    },

    borrarFiltrosAdicionales() {
      this.genero = [];
      this.id_ciudad = [];
      this.nivel_hijo = [];
      this.todosGeneros = false;
      this.todosCiudades = false;
      this.cargo = [];
      this.persona = [];
    },

    editItem(item) {
      this.id = item.id;
      this.id_subcategoria = item.id_subcategoria;
      this.formula = item.formula;
      this.monto = item.monto;
      this.es_porcentaje = item.es_porcentaje || false;
      this.mes_cumple = item.mes_cumple || false;
      this.mes_ingreso = item.mes_ingreso || false;
      this.particular = item.particular || false;
      this.para_padres = item.para_padres || false;
      
      this.mes = item.mes || [];
      this.genero = item.genero || [];
      this.id_ciudad = item.ciudad || [];
      this.nivel_hijo = item.nivel_hijo ? JSON.parse(item.nivel_hijo) : [];
      this.cargo = item.cargo || [];
      this.persona = item.persona || [];
      this.personasTableSelected = this.personas.filter(p => this.persona.includes(p.id));

      this.personasOrdenadas = [...this.personas].sort((a, b) => {
        const aSel = this.persona.includes(a.id);
        const bSel = this.persona.includes(b.id);
        if (aSel && !bSel) return -1;
        if (!aSel && bSel) return 1;
        return 0;
      });

      this.todosMeses = this.mes.length === this.meses.length && this.meses.length > 0;
      this.todosCiudades = this.id_ciudad.length === this.ciudades.length && this.ciudades.length > 0;
      this.todosGeneros = this.genero.length === this.generos.length && this.generos.length > 0;
      this.todosCargos = this.cargo.length === this.cargos.length && this.cargos.length > 0;

      this.editedIndex = 1;
      this.dialog = true;
    },

    addItem() {
      if(!this.id_presupuesto_filtro) {
        this.$store.dispatch("setSnackbar", { text: "Seleccione un presupuesto primero.", color: "warning" });
        return;
      }
      this.editedIndex = -1;
      this.dialog = true;
    },

    close() {
      this.dialog = false;
      this.limpiar();
    },

    limpiar() {
      this.id = "";
      this.id_subcategoria = "";
      this.formula = "";
      this.monto = 0;
      this.es_porcentaje = false;
      this.mes_cumple = false;
      this.mes_ingreso = false;
      this.particular = false;
      this.para_padres = false;
      this.mes = [];
      this.genero = [];
      this.id_ciudad = [];
      this.nivel_hijo = [];
      this.cargo = [];
      this.persona = [];
      this.personasTableSelected = [];
      this.personasOrdenadas = [...this.personas];
      this.searchPersona = "";
      this.editedIndex = -1;
    },

    guardar() {
      let me = this;
      if (this.validar() > 0) {
        this.$store.dispatch("setSnackbar", { text: "Verifique los errores e intente nuevamente.", color: "error" });
        return;
      }

      let payload = {
        id_presupuesto: me.id_presupuesto_filtro,
        id_subcategoria: me.id_subcategoria,
        monto: me.monto || 0,
        formula: me.formula,
        es_porcentaje: me.es_porcentaje,
        mes_cumple: me.mes_cumple,
        mes_ingreso: me.mes_ingreso,
        particular: me.particular,
        para_padres: me.para_padres,
        mes: me.mes,
        genero: me.genero,
        ciudad: me.id_ciudad,
        nivel_hijo: me.nivel_hijo && me.nivel_hijo.length > 0 ? JSON.stringify(me.nivel_hijo) : null,
        cargo: me.cargo,
        persona: me.persona,
        usuario: me.usuario
      };

      if (this.editedIndex > -1) {
        payload.id = me.id;
        axios.put("api/Subcategoria_configs/Actualizar", payload)
          .then(function () {
            me.close();
            me.listar();
            me.$store.dispatch("setSnackbar", { text: "Registro modificado exitosamente.", color: "success" });
          })
          .catch(function (error) {
            me.$store.dispatch("setSnackbar", { text: (error.response && error.response.data) ? error.response.data : "Error al actualizar", color: "error" });
          });
      } else {
        axios.post("api/Subcategoria_configs/Crear", payload)
          .then(function () {
            me.close();
            me.listar();
            me.$store.dispatch("setSnackbar", { text: "Registro creado exitosamente.", color: "success" });
          })
          .catch(function (error) {
            me.$store.dispatch("setSnackbar", { text: (error.response && error.response.data) ? error.response.data : "Error al crear", color: "error" });
          });
      }
    },

    validar() {
      this.valida = 0;
      Object.keys(this.form).forEach((f) => {
        if(this.$refs[f]) {
          this.$refs[f].validate(true);
          if (!this.$refs[f].validate(true)) {
            this.valida += 1;
          }
        }
      });
      return this.valida;
    },

    activar(item) {
      let me = this;
      axios.put("api/Subcategoria_configs/Activar/" + item.id)
        .then(function () {
          item.estado = 'A'; // Actualización optimista
          me.$store.dispatch("setSnackbar", { text: "Registro activado exitosamente.", color: "success" });
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", { text: "Error al activar: " + error, color: "error" });
        });
    },

    desactivar(item) {
      let me = this;
      axios.delete("api/Subcategoria_configs/Eliminar/" + item.id)
        .then(function () {
          me.listar();
          me.$store.dispatch("setSnackbar", { text: "Registro desactivado exitosamente.", color: "success" });
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", { text: error, color: "error" });
        });
    }
  },
};
</script>
